export const DYNAMIC_LABEL_COPY = {
  available: 'Available',
  ended: 'Ended',
  mintingOpen: 'Now minting',
  mintingSoon: 'Minting soon',
  sold: 'Sold',

  endsIn: (endsInMessage: string) => `Ends ${endsInMessage}`,
};
